import './index.css';
import { make } from '../../../utils';

import { IconAlignLeft, IconAlignCenter, IconAlignRight, IconAlignJustify } from '@codexteam/icons';

export default class Alignement {

  static get DEFAULT_ALIGNMENT() {
	return 'left';
  }

  static get isTune() {
	return true;
  }
  
  constructor({ api, data, config, block }) {
	this.api = api;
	this.block = block;

	this.config = config;
	this.data = data || this.getAlignment();
  }

  get alignments() {
	return [
	  {
		name: 'left',
		icon: IconAlignLeft,
		title: 'Align Left',
	  },
	  {
		name: 'center',
		icon: IconAlignCenter,
		title: 'Align Center',
	  },
	  {
		name: 'right',
		icon: IconAlignRight,
		title: 'Align Right',
	  },
	  {
		name: 'justify',
		icon: IconAlignJustify,
		title: 'Align Justify',
	  }
	]
  };

  get CSS() {
	return {
	  tuneContainer: 'aligner-container',
	  tuneLabel: 'aligner-label',
	  toggler: 'aligner-toggler',
	  alignment: {
		left: 'aligner--align-left',
		center: 'aligner--align-center',
		right: 'aligner--align-right',
		justify: 'aligner--align-justify',
	  }
	};
  };

  wrap(blockContent) {
	this.wrapper = make('div');
	this.wrapper.classList.toggle(this.CSS.alignment[this.data])
	this.wrapper.appendChild(blockContent);

	return this.wrapper;
  }

  render() {
	let tuneWrapper = make('div', [this.CSS.tuneContainer]);

	let tuneLabel = make('label', [this.CSS.tuneLabel])
	tuneLabel.innerHTML = this.api.i18n.t('Align Block')
	tuneWrapper.appendChild(tuneLabel);

	let togglers = this.alignments.map(({ name, icon, title }) => {
	  const toggler = make('button', [this.api.styles.settingsButton, this.CSS.toggler], {
		innerHTML: icon,
		type: 'button'
	  });

	  toggler.dataset.name = name;

	  this.api.tooltip.onHover(toggler, this.api.i18n.t(title), {
		placement: 'top',
		hidingDelay: 500,
	  });
	  tuneWrapper.appendChild(toggler);
	  return toggler;
	});

	togglers.forEach((element, index, elements) => {
	  element.addEventListener('click', () => {
		this.data = this.alignments[index].name;
		this.setUi(elements);
	  });
	});

	this.setUi(togglers);

	return tuneWrapper;
  }

  getAlignment() {
	if (!!this.config?.blocks && this.config.blocks.hasOwnProperty(this.block.name)) {
	  return this.config.blocks[this.block.name]
	}
	if (!!this.config?.default) {
	  return this.config.default
	}
	return AlignerTune.DEFAULT_ALIGNMENT
  }

  setUi(elements) {
	elements.forEach((element, idx) => {
	  const { name } = this.alignments[idx];
	  let force = name === this.data;
	  element.classList.toggle(this.api.styles.settingsButtonActive, force);
	  this.wrapper.classList.toggle(this.CSS.alignment[name], force)
	});
  }

  save() {
	return this.data;
  }
}